/**
 * Supabase Client
 *
 * Configured using environment variables:
 * - SUPABASE_URL: Full project URL (e.g., https://xxx.supabase.co)
 * - SUPABASE_ANON_KEY: Public anon key for client-side access
 */
import { createClient, SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.SUPABASE_URL;
const supabaseAnonKey = process.env.SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    "[Supabase] Missing environment variables. Set SUPABASE_URL and SUPABASE_ANON_KEY in .env"
  );
}

export const supabase: SupabaseClient | null =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          flowType: "pkce",
        },
      })
    : null;

// Alias for backwards compatibility with MandelbrotControls
export const client = supabase;

// Session ID for analytics
export let sessionId = `${Math.random()}|${Date.now()}`;
try {
  sessionId = self.crypto.randomUUID() || sessionId;
} catch {
  console.warn("crypto.randomUUID() not available");
}
